import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { AddProjectRequests } from './add-project.requests';
import * as AddProjectActions from './add-project.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { AddProjectErrors } from '@app/models/add-project';

@Injectable()
export class AddProjectEffects {
    constructor(
        private actions$: Actions,
        private addProjectRequests: AddProjectRequests
    ) {}

    submitAddProject$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AddProjectActions.AddProjectActionType.SubmitAddProject),
            mergeMap((action: AddProjectActions.SubmitAddProject) =>
                this.addProjectRequests.submitAddProject$(action.payload).pipe(
                    map((project) => new AddProjectActions.SubmitAddProjectSuccess(project)),
                    catchError((error: HttpErrorResponse) =>
                        of(new AddProjectActions.SubmitAddProjectFailure(error))
                    )
                )
            )
        )
    );

    handleErrors$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AddProjectActions.AddProjectActionType.SubmitAddProjectFailure),
            map((action: AddProjectActions.SubmitAddProjectFailure) => {
                const error = action.error;
                const errorFlags: Partial<AddProjectErrors> = {};

                if (error.status === 403) {
                    // console.error("Forbidden error 403");
                    errorFlags.forbidden = true;
                } else if (error.status === 401) {
                    // console.error("Unauthorized error 401");
                    errorFlags.unauthorized = true;
                } else if (error.status === 406) {
                    const errorCode = error.error?.code;
                    switch (errorCode) {
                        case 'request_due_date_past_error':
                            errorFlags.due_date = true;
                            break;
                        case 'request_information_empty':
                            errorFlags.info = true;
                            break;
                        case 'request_tags_empty':
                        case 'label_not_in_organization':
                        case 'label_not_exist':
                            errorFlags.labels = true;
                            break;
                        case 'temporal_file_not_exists':
                        case 'file_not_in_organization':
                        case 'file_not_exist':
                            errorFlags.files = true;
                            break;
                        case 'version_not_exist':
                        case 'version_not_in_organization':
                            errorFlags.version = true;
                            break;
                        case 'workflow_not_exist':
                        case 'workflow_not_in_organization':
                            errorFlags.workflow = true;
                            break;
                        default:
                            // console.error("Unknown error code:", errorCode);
                            errorFlags.other = true;
                    }
                } else {
                    errorFlags.server = true;
                }

                return new AddProjectActions.SetErrors(errorFlags);
            })
        )
    );
}